(function() {
  var loaded = false;

  var activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

  function activateDeferred() {
    if (loaded) return;
    loaded = true;

    activityEvents.forEach(function(name) {
      window.removeEventListener(name, activateDeferred, false);
    });

    document.querySelectorAll('script[data-src]').forEach(function(el) {
      el.src = el.dataset.src;
      delete el.dataset.src;
    });

    document.querySelectorAll('link[data-href]').forEach(function(el) {
      el.href = el.dataset.href;
      delete el.dataset.href;
    });

    document.querySelectorAll('.deferredScript').forEach(function(el) {
      el.type = 'text/javascript';
    });

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
      document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    }, 400);
  }

  activityEvents.forEach(function(name) {
    window.addEventListener(name, activateDeferred, { once: true, passive: true });
  });

  window.addEventListener('load', function() {
    setTimeout(activateDeferred, 9000);
  });
})();

/* === APO gate fix (2026-07-16) ===
   On product pages where MageWorx APO has no options (Apliiq/Printful POD items),
   window.mwApoReady stays false forever, so the theme's VariantSelects code disables
   Add-to-Cart and waits out an 8s timeout. This releases the gate immediately on
   products that have no APO instance. APO products (which register an instance and/or
   set mwApoReady=true) are left untouched. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function apoActive() {
    try {
      return !!(window.mwApo && typeof window.mwApo.instances === 'function' && window.mwApo.instances().length > 0);
    } catch (e) { return false; }
  }
  function release() {
    if (window.mwApoReady === true) return;
    if (apoActive()) return;
    window.mwApoReady = true;
    try {
      document.dispatchEvent(new CustomEvent('mw-apo:ready', { detail: { source: 'custom-js-no-apo-fix' } }));
    } catch (e) {}
  }
  var started = Date.now();
  var poll = setInterval(function () {
    if (apoActive() || window.mwApoReady === true) { clearInterval(poll); return; }
    if (Date.now() - started > 2500) { clearInterval(poll); release(); }
  }, 150);
})();
